
export const GET_FORMS = `/forms/patient`;
export const GET_INFO = "/forms/info";
export const GET_INVITEE_FORMS = (inviteeId:number) => `/forms/invitee/${inviteeId}`;
export const GET_FORM = (formId: string) => `/forms/${formId}`;
export const START_RESPONSE = (formVersionId: string) => `forms/versions/${formVersionId}/start`; 
export const RECORD_ANSWER = (formVersionId: string, responseId: string) => `forms/${formVersionId}/responses/${responseId}/answer`; 
export const RECORD_ANSWERS = (formVersionId: string, responseId: string) => `forms/${formVersionId}/responses/${responseId}/answers`; 
export const GET_TAKER = (inviteeId: number) => `forms/taker?${inviteeId ? "inviteeId=" + inviteeId : ""}`;

export const VERIFY_ENROL_LINK = (code: string) => `login/verify-enrol?code=${code}`;
export const RESENDONETIMECODE = `login/otp/resend`;
export const VERIFYONETIMECODE = `login/otp/verify`;
export const SENDMAGICLINK = `login/magic`;
export const VERIFYMAGICLINK = `login/magic/verify`;
export const SELECTACCOUNT = `login/select-account`;